'use client';

import { Typography } from '@musinsa/mds';
import { useRemoveCommonLayout } from '@musinsa/mds-ui';
import { SERVICE, type ServiceType } from '@musinsa/packages-device-detection';
import Image from 'next/image';
import { useNavigate } from '../../hooks/useNavigate';
import { getCdnUrl } from '../../utils';
import { ErrorContainer } from './ErrorContainer';

interface NotFoundProps {
  className?: string;
  service?: ServiceType;
}

export function NotFound({ className, service }: NotFoundProps) {
  const { navigateBack, navigateReplace } = useNavigate();

  useRemoveCommonLayout({ removeAppBar: true, removeFooter: true });

  const handleGoBack = () => {
    navigateBack();
  };

  const handleGoHome = () => {
    const homeUrl =
      service === SERVICE.MUSINSA
        ? process.env.NEXT_PUBLIC_MUSINSA_BASE_URL
        : process.env.NEXT_PUBLIC_29CM_BASE_URL;
    navigateReplace(`${homeUrl}/`);
  };

  const logo =
    service === SERVICE.MUSINSA ? (
      <Image
        src={'https://image.msscdn.net/static/assets/bi/error_logo_musinsa.png'}
        alt="무신사 로고"
        width={100}
        height={17}
      />
    ) : (
      <Image src={getCdnUrl('/images/logo/29-logo.png')} alt="29cm 로고" width={60} height={16} />
    );

  const description = (
    <>
      <Typography variant="body13pxReg" colorScheme="gray-600">
        페이지 주소가 잘못되었거나 알 수 없는 오류가 발생했습니다.
      </Typography>
      <br />
      <Typography variant="body13pxReg" colorScheme="gray-600">
        입력한 주소를 다시 확인해 주세요.
      </Typography>
    </>
  );

  const actions = [
    { label: '이전 페이지', onClick: handleGoBack },
    { label: '홈으로 이동', onClick: handleGoHome },
  ];

  return (
    <ErrorContainer
      logo={logo}
      title="페이지를 찾을 수 없습니다."
      description={description}
      actions={actions}
      className={className}
    />
  );
}
